import { MdArrowForward } from 'react-icons/md';
import { OpeningDaysHistory } from 'types';
import { formatMillisecondsToHours } from 'helpers';
import { weekdayName } from 'commons';

function displayTime(milliseconds: number | undefined) {
  if (!milliseconds) return 'Fechada';

  const { hours, minutes } = formatMillisecondsToHours(milliseconds);

  return `${hours}:${minutes}`;
}

const STORE_OPENING = 'openingTime';

interface Props {
  historyEntry: OpeningDaysHistory;
}

export function OpeningHistoryContent({ historyEntry }: Props) {
  const { entries, weekday } = historyEntry;

  const weekdayFullName = weekdayName[weekday.toLowerCase()]?.complete;

  entries.sort((a) => (a.type === STORE_OPENING ? -1 : 1));

  function renderDate(date: number) {
    return <span className="min-w-11 text-center">{displayTime(date)}</span>;
  }

  return (
    <div className="flex flex-col gap-0.5 text-font12">
      <span className="font-bold">{weekdayFullName}</span>

      <div className="flex flex-col gap-2 pt-2">
        {entries.map((entry) => {
          const { newDate, oldDate, type } = entry;

          const storeState = type === STORE_OPENING ? 'Abertura' : 'Fechamento';

          return (
            <div className="flex flex-col gap-1">
              <span className="text-font10 font-bold">{storeState}</span>

              <div className="flex items-center gap-2">
                {renderDate(oldDate)}

                <MdArrowForward size={12} />

                {renderDate(newDate)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
